export type PhotoCrop = { x: number; y: number; width: number; height: number };

/** Reject invalid coordinates; the saved square must match the visible crop. */
export function profilePhotoCropBounds(width: number, height: number, crop: PhotoCrop) {
  if (![crop.x, crop.y, crop.width, crop.height].every(Number.isFinite) ||
    crop.x < 0 || crop.y < 0 || crop.width <= 0 || crop.height <= 0 ||
    crop.x + crop.width > width + 1 || crop.y + crop.height > height + 1) {
    throw new Error("Invalid image crop.");
  }
  return { ...crop, width: Math.min(crop.width, width - crop.x), height: Math.min(crop.height, height - crop.y) };
}

export const profilePhotoCropService = {
  async prepare(file: File, crop: PhotoCrop | null): Promise<File> {
    if (!crop) throw new Error("Choose a crop before saving.");
    const bitmap = await createImageBitmap(file);
    try {
      const canvas = document.createElement("canvas");
      canvas.width = 768;
      canvas.height = 768;
      const context = canvas.getContext("2d");
      if (!context) throw new Error("Image preparation unavailable.");
      const { x, y, width, height } = profilePhotoCropBounds(bitmap.width, bitmap.height, crop);
      context.drawImage(bitmap, x, y, width, height, 0, 0, canvas.width, canvas.height);
      const blob = await new Promise<Blob>((resolve, reject) => canvas.toBlob(
        (value) => value ? resolve(value) : reject(new Error("Image preparation failed.")), "image/jpeg", 0.85
      ));
      return new File([blob], "profile-photo.jpg", { type: "image/jpeg" });
    } finally { bitmap.close(); }
  },
};
